import AttendanceModel from '../Apis/Attendance'
import Controller from './Controller'

export default class AttendanceController extends Controller {
  constructor() {
    super(new AttendanceModel())
  }

  async getAttendanceByDate(params) {
    return await this.model.getAttendanceByDate(params)
  }
}
